


import Vue from "vue";
import {Component} from "vue-property-decorator";
import NavigationBar from "@/components/navigation-bar/NavigationBar.vue";

@Component({
  name: 'App',
  components: {
    NavigationBar
  }})
export default class App extends Vue {}
